import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["disabled", "error", "theme", "warning"],
    _excluded2 = ["placeholder", "children", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { describe, PropTypes } from '@amzn/stencil-react-desc';
import { styledWithTheme } from "../../../context";
import { alignSelfPropTypes, flexPropTypes, formElementPropTypes, widthWithMinMaxPropTypes } from "../../../prop-types";
import { disabledIconStyles, disabledStyles, inputStyles, selectChevronIconStyles, combineBackgroundIconStyles } from "../../../styles";
import { filterPropsFromPropTypes, getPropsStyles, getSpacingStyles, withTestAttributes } from "../../../utils";
import Option from "./Option";
import { jsx as ___EmotionJSX } from "@emotion/core";

var SelectBasePropTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, alignSelfPropTypes), flexPropTypes), formElementPropTypes), widthWithMinMaxPropTypes);

var SelectBase = styledWithTheme('select', {
  shouldForwardProp: filterPropsFromPropTypes(SelectBasePropTypes, {
    filterInvalidHTML: true,
    propsToForward: ['disabled'],
    additionalPropsToFilter: ['placeholder']
  })
})(function (_ref) {
  var disabled = _ref.disabled,
      error = _ref.error,
      theme = _ref.theme,
      warning = _ref.warning,
      props = _objectWithoutProperties(_ref, _excluded);

  var selectors = theme.selectors;
  var hasAriaDisabled = !!props['aria-disabled'];
  var iconsStyles = hasAriaDisabled ? disabledIconStyles({
    disabled: true,
    theme: theme
  }) : combineBackgroundIconStyles(disabledIconStyles({
    disabled: disabled,
    theme: theme
  }), selectChevronIconStyles({
    disabled: disabled,
    error: error,
    warning: warning,
    theme: theme
  }));
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, inputStyles({
    error: error,
    warning: warning,
    props: props,
    selectors: selectors
  })), disabledStyles({
    disabled: disabled || hasAriaDisabled,
    error: error,
    warning: warning,
    selectors: selectors
  })), getPropsStyles(['display', 'flex', 'alignSelf'], props)), getSpacingStyles(['width', 'minWidth', 'maxWidth', 'margin'], props, selectors.space)), iconsStyles), {}, {
    cursor: 'pointer',
    appearance: 'none',
    WebkitAppearance: 'none',
    borderRadius: 0,
    wordWrap: 'break-word',
    whiteSpace: 'normal'
  });
});
SelectBase.defaultProps = {
  display: 'block',
  maxWidth: '100%'
};
var Select = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var placeholder = _ref2.placeholder,
      children = _ref2.children,
      value = _ref2.value,
      props = _objectWithoutProperties(_ref2, _excluded2);

  return ___EmotionJSX(SelectBase, _extends({
    value: value,
    ref: ref
  }, props), !!placeholder && ___EmotionJSX(Option, {
    value: "",
    disabled: true
  }, placeholder), children);
});
var SelectWithDocs = describe(Select).description('Form element used for selecting options from a dropdown menu.');
SelectWithDocs.propTypes = _objectSpread(_objectSpread({}, SelectBasePropTypes), {}, {
  placeholder: PropTypes.string.description('Adds a placeholder option so that no valid option is selected by default')
});
var SelectWithTestAttributes = withTestAttributes({
  component: 'StencilReactSelect'
})(SelectWithDocs);
SelectWithTestAttributes.displayName = 'Select';
export default SelectWithTestAttributes;